export default {
    max: 'この値は {{max}} 以下でなければなりません。',
    min: 'この値は {{min}} 以上でなければなりません。',
};
